import { c as _c } from "react/compiler-runtime";
import ProfileAvatar, { ProfileBadgeSize } from "@/components/common/profile/ProfileAvatar";
import { DropPartSize } from "@/components/drops/view/part/DropPart.types";
const AVATAR_SIZE_MAP: Record<DropPartSize, ProfileBadgeSize> = {
  [DropPartSize.SMALL]: ProfileBadgeSize.SMALL,
  [DropPartSize.MEDIUM]: ProfileBadgeSize.MEDIUM,
  [DropPartSize.LARGE]: ProfileBadgeSize.LARGE
};
export default function DropPfp(t0) {
  const $ = _c(3);
  const {
    pfpUrl,
    size,
    profileSize
  } = t0;
  const effectiveSize = profileSize ?? AVATAR_SIZE_MAP[size ?? DropPartSize.MEDIUM];
  let t1;
  if ($[0] !== effectiveSize || $[1] !== pfpUrl) {
    t1 = <ProfileAvatar pfpUrl={pfpUrl} size={effectiveSize} alt="Create Drop Profile" />;
    $[0] = effectiveSize;
    $[1] = pfpUrl;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}